<div class="aca-admin aca-fields">
  <aca-page-header *ngIf="!embedded" icon="view_list" [title]="'DMS.FIELDS.TITLE' | translate" [subtitle]="'DMS.FIELDS.SUBTITLE' | translate" />

  <div class="aca-fields__notice" *ngIf="canEdit() === false">
    <mat-icon>lock</mat-icon>
    <p>{{ 'DMS.DOCUMENT_TYPES.READONLY_NOTE' | translate }}</p>
  </div>

  <mat-progress-bar mode="indeterminate" *ngIf="loading() || saving()" />

  <aca-page-state
    *ngIf="failed()"
    state="error"
    [title]="'DMS.FIELDS.LOAD_FAIL' | translate"
    [message]="failed()"
    [actionLabel]="'DMS.UI.324E7E' | translate"
    (action)="reload()"
  />

  <aca-page-state
    *ngIf="!failed() && !loading() && schemaMissing()"
    state="empty"
    icon="view_list"
    [title]="'DMS.DOCUMENT_TYPES.ED8929' | translate"
    [message]="'DMS.UI.3C7EAA' | translate"
  />

  <section class="aca-fields__card" *ngIf="!failed() && !schemaMissing()">
    <div class="aca-fields__head">
      <span class="aca-fields__headtext">
        <h3 class="aca-fields__title">{{ 'DMS.FIELDS.TITLE' | translate }}</h3>
        <span class="aca-fields__note">{{ 'DMS.DOCUMENT_TYPES.5AC57B' | translate }}<code>dms:documentInfo</code>)</span>
      </span>
      <button type="button" class="aca-fields__primary" *ngIf="canEdit()" [disabled]="saving()" (click)="startAdd()">
        <mat-icon>add</mat-icon>{{ 'DMS.FIELDS.ADD' | translate }}
      </button>
    </div>

    <!-- the form, used both for a new field and for changing one -->
    <div class="aca-fields__draft" *ngIf="editing() !== null">
      <div class="aca-fields__draftrow">
        <label class="aca-fields__field">
          <span class="aca-fields__label">{{ 'DMS.FIELDS.F_NAME' | translate }}</span>
          <input class="aca-fields__input" [(ngModel)]="draftLabel" [placeholder]="'DMS.FIELDS.F_NAME_PH' | translate" autocomplete="off" />
        </label>

        <label class="aca-fields__field" *ngIf="!editing()">
          <span class="aca-fields__label">{{ 'DMS.FIELDS.F_CODE' | translate }}</span>
          <input class="aca-fields__input" [(ngModel)]="draftCode" [placeholder]="codePreview || 'dms:myField'" autocomplete="off" />
          <span class="aca-fields__hint">{{ 'DMS.FIELDS.F_CODE_HINT' | translate: { p0: codePreview || '—' } }}</span>
        </label>

        <label class="aca-fields__field">
          <span class="aca-fields__label">{{ 'DMS.FIELDS.F_KIND' | translate }}</span>
          <select class="aca-fields__input" [(ngModel)]="draftKind" [disabled]="!!editing()">
            <option *ngFor="let kind of kinds" [value]="kind.id">{{ kind.label | translate }}</option>
          </select>
          <span class="aca-fields__hint">{{ (editing() ? 'DMS.FIELDS.F_KIND_LOCKED' : 'DMS.FIELDS.F_KIND_HINT') | translate }}</span>
        </label>

        <label class="aca-fields__field">
          <span class="aca-fields__label">{{ 'DMS.FIELDS.F_DEFAULT' | translate }}</span>
          <input class="aca-fields__input" [(ngModel)]="draftDefault" [placeholder]="'DMS.FIELDS.F_DEFAULT_PH' | translate" autocomplete="off" />
          <span class="aca-fields__hint">&nbsp;</span>
        </label>
      </div>

      <label class="aca-fields__field aca-fields__field--wide" *ngIf="needsStartingValues">
        <span class="aca-fields__label">{{ 'DMS.FIELDS.F_OPTIONS' | translate }}</span>
        <textarea class="aca-fields__textarea" [(ngModel)]="draftOptions" [placeholder]="'DMS.FIELDS.F_OPTIONS_PH' | translate" rows="4"></textarea>
        <span class="aca-fields__hint">{{ 'DMS.FIELDS.F_OPTIONS_HINT' | translate }}</span>
      </label>

      <!-- an existing list has a manager of its own, where each value's usage
           is known before anything is taken away -->
      <p class="aca-fields__hint" *ngIf="kind.list && editing()"><mat-icon>list</mat-icon>{{ 'DMS.FIELDS.F_OPTIONS_MANAGED' | translate }}</p>

      <div class="aca-fields__draftactions">
        <button type="button" class="aca-fields__outline" (click)="cancelEdit()">{{ 'DMS.UI.7D3094' | translate }}</button>
        <button type="button" class="aca-fields__primary" [disabled]="!canSaveDraft()" (click)="saveDraft()">
          <mat-icon>save</mat-icon>{{ 'DMS.UI.6EA45A' | translate }}
        </button>
      </div>
    </div>

    <div class="aca-fields__tablewrap">
      <table class="aca-fields__table">
        <thead>
          <tr>
            <th class="aca-fields__th aca-fields__th--name">{{ 'DMS.DOCUMENT_TYPES.138847' | translate }}</th>
            <th class="aca-fields__th">QName</th>
            <th class="aca-fields__th">{{ 'DMS.DOCUMENT_TYPES.50A388' | translate }}</th>
            <th class="aca-fields__th">{{ 'DMS.DOCUMENT_TYPES.F6E92F' | translate }}</th>
            <th class="aca-fields__th">{{ 'DMS.DOCUMENT_TYPES.A554E3' | translate }}</th>
            <th class="aca-fields__th aca-fields__th--actions">{{ 'DMS.DOCUMENT_TYPES.822854' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let field of fields(); trackBy: trackById">
            <tr class="aca-fields__row">
              <td class="aca-fields__td aca-fields__td--name">
                <span class="aca-fields__name">{{ field.label | translate }}</span>
                <span class="aca-fields__badge" *ngIf="builtIn(field)">{{ 'DMS.FIELDS.BUILT_IN' | translate }}</span>
              </td>
              <td class="aca-fields__td">
                <code class="aca-fields__code">{{ field.id }}</code>
              </td>
              <td class="aca-fields__td">{{ kindOf(field) }}</td>
              <td class="aca-fields__td">{{ (field.defaultValue | translate) || '—' }}</td>
              <td class="aca-fields__td aca-fields__td--options">
                <span class="aca-fields__chip" *ngFor="let option of field.options">{{ option.label | translate }}</span>
                <span class="aca-fields__free" *ngIf="!field.options.length">{{ 'DMS.DOCUMENT_TYPES.F61873' | translate }}</span>
              </td>
              <td class="aca-fields__td aca-fields__td--actions">
                <span class="aca-fields__acts" *ngIf="canEdit()">
                  <button
                    type="button"
                    class="aca-fields__values"
                    *ngIf="isList(field)"
                    [class.aca-fields__values--on]="managing()?.id === field.id"
                    [disabled]="saving()"
                    (click)="manageValues(field)"
                  >
                    <mat-icon>{{ managing()?.id === field.id ? 'expand_less' : 'tune' }}</mat-icon>
                    {{ 'DMS.FIELDS.MANAGE_VALUES' | translate }}
                  </button>
                  <button
                    type="button"
                    class="aca-fields__iconbtn"
                    [disabled]="saving()"
                    [matTooltip]="'DMS.FIELDS.EDIT' | translate"
                    [attr.aria-label]="'DMS.FIELDS.EDIT' | translate"
                    (click)="startEdit(field)"
                  >
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button
                    type="button"
                    class="aca-fields__iconbtn aca-fields__iconbtn--danger"
                    [disabled]="builtIn(field) || saving()"
                    [matTooltip]="(builtIn(field) ? 'DMS.FIELDS.DELETE_BUILT_IN' : 'DMS.FIELDS.DELETE') | translate"
                    [attr.aria-label]="'DMS.FIELDS.DELETE' | translate"
                    (click)="remove(field)"
                  >
                    <mat-icon>delete_outline</mat-icon>
                  </button>
                </span>
              </td>
            </tr>

            <!-- the values that field allows, opened from the button above -->
            <tr class="aca-fields__valuesrow" *ngIf="managing()?.id === field.id">
              <td class="aca-fields__valuescell" colspan="6">
                <div class="aca-fields__panel">
                  <div class="aca-fields__panelhead">
                    <h4>{{ 'DMS.FIELDS.VALUES_TITLE' | translate: { p0: (field.label | translate) } }}</h4>
                    <button type="button" class="aca-fields__iconbtn" (click)="closeValues()" [attr.aria-label]="'DMS.UI.7D3094' | translate">
                      <mat-icon>close</mat-icon>
                    </button>
                  </div>

                  <table class="aca-fields__valuestable">
                    <thead>
                      <tr>
                        <th>{{ 'DMS.FIELDS.VALUE_NAME' | translate }}</th>
                        <th>{{ 'DMS.FIELDS.VALUE_CODE' | translate }}</th>
                        <th>{{ 'DMS.FIELDS.VALUE_USAGE' | translate }}</th>
                        <th class="aca-fields__valuesactions">{{ 'DMS.DOCUMENT_TYPES.822854' | translate }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let option of field.options">
                        <td>
                          <span *ngIf="renaming() !== option.value">{{ option.label | translate }}</span>
                          <input
                            class="aca-fields__input aca-fields__input--inline"
                            *ngIf="renaming() === option.value"
                            [(ngModel)]="renameLabel"
                            (keyup.enter)="saveValueName(option.value)"
                            (keyup.escape)="cancelRenameValue()"
                            [attr.aria-label]="'DMS.FIELDS.VALUE_NAME' | translate"
                          />
                        </td>
                        <td>
                          <code class="aca-fields__code">{{ option.value }}</code>
                        </td>
                        <td>
                          <span *ngIf="usageLoading()">…</span>
                          <span *ngIf="!usageLoading()">{{ 'DMS.FIELDS.VALUE_DOCS' | translate: { p0: countOf(option.value) ?? 0 } }}</span>
                        </td>
                        <td class="aca-fields__valuesactions">
                          <span class="aca-fields__acts" *ngIf="renaming() !== option.value">
                            <button
                              type="button"
                              class="aca-fields__iconbtn"
                              [disabled]="saving()"
                              [matTooltip]="'DMS.FIELDS.VALUE_RENAME' | translate"
                              [attr.aria-label]="'DMS.FIELDS.VALUE_RENAME' | translate"
                              (click)="startRenameValue(option)"
                            >
                              <mat-icon>edit</mat-icon>
                            </button>
                            <button
                              type="button"
                              class="aca-fields__iconbtn aca-fields__iconbtn--danger"
                              [disabled]="!canRemoveValue(option.value)"
                              [matTooltip]="removeReason(option.value) | translate"
                              [attr.aria-label]="'DMS.FIELDS.VALUE_DELETE' | translate"
                              (click)="removeValue(option)"
                            >
                              <mat-icon>delete_outline</mat-icon>
                            </button>
                          </span>
                          <span class="aca-fields__acts" *ngIf="renaming() === option.value">
                            <button type="button" class="aca-fields__outline" (click)="cancelRenameValue()">
                              {{ 'DMS.UI.7D3094' | translate }}
                            </button>
                            <button type="button" class="aca-fields__primary" [disabled]="saving()" (click)="saveValueName(option.value)">
                              {{ 'DMS.UI.6EA45A' | translate }}
                            </button>
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <div class="aca-fields__addvalue">
                    <label class="aca-fields__field">
                      <span class="aca-fields__label">{{ 'DMS.FIELDS.VALUE_NAME' | translate }}</span>
                      <input class="aca-fields__input" [(ngModel)]="newValueLabel" [placeholder]="'DMS.FIELDS.VALUE_NAME_PH' | translate" />
                    </label>
                    <label class="aca-fields__field">
                      <span class="aca-fields__label">{{ 'DMS.FIELDS.VALUE_CODE' | translate }}</span>
                      <input class="aca-fields__input" [(ngModel)]="newValueCode" [placeholder]="newValueCodePreview || 'value-code'" />
                      <span class="aca-fields__hint">{{ 'DMS.FIELDS.VALUE_CODE_HINT' | translate: { p0: newValueCodePreview || '—' } }}</span>
                    </label>
                    <button
                      type="button"
                      class="aca-fields__primary aca-fields__primary--afterlabel"
                      [disabled]="!canAddValue()"
                      (click)="addValue()"
                    >
                      <mat-icon>add</mat-icon>{{ 'DMS.FIELDS.VALUE_ADD' | translate }}
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </section>
</div>
